// extracted by mini-css-extract-plugin
export default {"uploadPhotoContainer":"uploadPhotoContainer-Brgiw","cameraIcon":"cameraIcon-r8xv_","imageCircle":"imageCircle-gqH1q","label":"label-WsyCN"};